import { useEffect, useMemo, useState } from 'react';
import { memberApi } from '@formosa/shared/api/member';
import {
  filterCountriesByEnNames,
  normalizeCountryList,
  pickDefaultCountry,
} from '@formosa/shared/utils/countryUtils';

/**
 * 載入 country-list（splitAreaCode=true）並可選依 enNames 過濾。
 */
export function useCountryOptions(allowedEnNames) {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const allowedKey = useMemo(() => {
    if (!Array.isArray(allowedEnNames) || allowedEnNames.length === 0) {
      return '';
    }
    return allowedEnNames.join('|');
  }, [allowedEnNames]);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');

    memberApi
      .listCountries({ splitAreaCode: true })
      .then((list) => {
        if (cancelled) {
          return;
        }
        const normalized = normalizeCountryList(list);
        const enNameList = allowedKey ? allowedKey.split('|') : [];
        setCountries(filterCountriesByEnNames(normalized, enNameList));
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err?.message || '國家列表載入失敗');
          setCountries([]);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [allowedKey]);

  const defaultCountry = useMemo(() => pickDefaultCountry(countries), [countries]);

  return { countries, loading, error, defaultCountry };
}
